import { useEffect } from "react";

const SEO = ({ title, description, keywords, canonical, image, noindex = false }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const updateMetaTag = (selector, attribute, value) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, value);
      } else {
        const isMeta = selector.startsWith("meta");
        const tag = isMeta ? "meta" : "link";
        element = document.createElement(tag);

        if (selector.includes("property=")) {
          const propMatch = selector.match(/property="([^"]+)"/);
          if (propMatch) element.setAttribute("property", propMatch[1]);
        } else if (selector.includes("name=")) {
          const nameMatch = selector.match(/name="([^"]+)"/);
          if (nameMatch) element.setAttribute("name", nameMatch[1]);
        } else if (selector.includes("rel=")) {
          const relMatch = selector.match(/rel="([^"]+)"/);
          if (relMatch) element.setAttribute("rel", relMatch[1]);
        }

        element.setAttribute(attribute, value);
        document.head.appendChild(element);
      }
    };

    if (noindex) {
      updateMetaTag('meta[name="robots"]', "content", "noindex, nofollow");
    } else {
      updateMetaTag('meta[name="robots"]', "content", "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1");
    }

    if (description) {
      updateMetaTag('meta[name="description"]', "content", description);
      updateMetaTag('meta[property="og:description"]', "content", description);
      updateMetaTag('meta[property="twitter:description"]', "content", description);
    }

    if (keywords) {
      updateMetaTag('meta[name="keywords"]', "content", keywords);
    }

    if (canonical) {
      updateMetaTag('link[rel="canonical"]', "href", canonical);
      updateMetaTag('meta[property="og:url"]', "content", canonical);
      updateMetaTag('meta[property="twitter:url"]', "content", canonical);
    }

    if (title) {
      updateMetaTag('meta[property="og:title"]', "content", title);
      updateMetaTag('meta[property="twitter:title"]', "content", title);
    }

    if (image) {
      updateMetaTag('meta[property="og:image"]', "content", image);
      updateMetaTag('meta[property="twitter:image"]', "content", image);
    }
  }, [title, description, keywords, canonical, image, noindex]);

  return null;
};

export default SEO;

